module.exports = __webpack_public_path__ + "static/media/03_360.63154041.jpeg";